<template>
<ul>
  <li v-for="(item, index) in items" :key="`menu-${index}`">
    <label v-if="item.heading && checkRule(item.roles)">{{ $t(item.heading) }}</label>
    <default-list-group v-else-if="item.children && item.children.length && checkRule(item.roles)"
      :item="item"/>
    <default-list-item v-else-if="checkRule(item.roles)"
      :key="`item-${index}`"
      :item="item"/>
  </li>
</ul>
</template>

<script>
import DefaultListGroup from './ListGroup'
import DefaultListItem from './ListItem'
import { get } from 'vuex-pathify'

export default {
  name: 'DefaultList',
  components: {
    DefaultListGroup,
    DefaultListItem
  },
  props: {
    items: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    userRole: get('user/role')
  },
  methods: {
    checkRule(roles) {
      if (!roles) {
        roles = ['admin', 'employee']
      }
      return roles.includes(this.userRole)
    }
  }
}
</script>
